import React, {Component, ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {getLinkPath} from 'app/utils/link_helper';
import {i18n_t} from 'app/i18n';
import {countedTitle} from 'app/utils/countedTitle';
import AlertPoint from 'app/components/AlertPoint';
import {closeMenuAndScrollToTop} from 'app/utils';
import NotificationsLink from 'site_version/common/NotificationsLink';
import BonusInterface from 'app/interfaces/BonusInterface';
import SteamTradeInterface from 'app/interfaces/SteamTradeInterface';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import toNumber from 'app/utils/toNumber';

interface UserNavProps {
    sections: {
        svg: string,
        icon_height: string,
        icon_width: string,
        path: string,
        translate: string,
        alert?: (() => void | SteamTradeInterface)
    }[]
    onClose?: () => void;
    bonuses: BonusInterface[]
    children?: React.ReactNode
    free_spins_count: number
}

export default class UserNav extends Component<UserNavProps> {
    onClose = (): void => {
        this.props.onClose?.();
        closeMenuAndScrollToTop();
    };

    render(): ReactNode {
        const {sections, children, bonuses, free_spins_count} = this.props;
        return <div className="user-nav">
            {sections.map(section => section.translate === 'messages'
                ? <NotificationsLink key="notifications" onClose={this.onClose}/>
                : <Link
                    to={getLinkPath(section.path)}
                    onClick={this.onClose}
                    key={section.translate} className="user-nav__item"
                >
                    <span className="user-nav__icon">
                        <SpriteIcon name={`#svg-${section.svg || section.translate}`}
                            size={{height: toNumber(section.icon_height), width: toNumber(section.icon_width)}}/>
                        {section.alert && section.alert() && <AlertPoint/>}
                    </span>
                    <span>
                        {i18n_t(`user.${section.translate}`)}
                        {section.translate === 'my_bonuses' && countedTitle('', bonuses.length)}
                        {section.translate === 'my_freespins' && countedTitle('', free_spins_count)}
                    </span>
                </Link>)}
            {children}
        </div>;
    }
}
